import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

import foundations from "@assets/theme/foundations";
import { recipes } from "@assets/theme/recipes";
import { slotRecipes } from "@assets/theme/recipes/slotRecipes";

import { FONT_FAMILY } from "./foundations/textStyle";
import globalCss from "./global";

const config = defineConfig({
  globalCss,
  theme: {
    keyframes: {
      loaderRotate: {
        "100%": { transform: "rotate(1turn)" },
      },
    },
    breakpoints: {
      sm: "440px",
      md: "768px",
      lg: "1024px",
      xl: "1200px",
      "2xl": "1400px",
    },
    tokens: {
      colors: foundations.colors,
      radii: foundations.borderRadius,
      fonts: {
        heading: { value: FONT_FAMILY.PRIMARY },
        body: { value: FONT_FAMILY.PRIMARY },
      },
      spacing: {
        blockMargin: { value: "16px" },
      },
    },
    semanticTokens: {
      colors: {
        border: { value: "#E2E8F0" },
      },
    },
    layerStyles: {
      disabled: {
        value: { opacity: "0.4", cursor: "not-allowed" },
      },
    },
    textStyles: foundations.textStyles,
    recipes,
    slotRecipes,
  },
});

export const theme = createSystem(defaultConfig, config);

export default theme;
